export default __webpack_public_path__ + "static/media/logo.adc2a039.png";